module.exports = __webpack_public_path__ + "static/web-painting-7-0a409cc2c945a0429baaf4ae3bd7b86a.jpg";